// import Icon from "./Icon";

// /* A clickable banner card: image/gradient banner + title.
//    Clicking anywhere on the banner (or title) opens the detail view. */
// export default function BannerCard({ item, index, onOpen }) {
//   return (
//     <button
//       onClick={() => onOpen(item)}
//       className="group relative flex h-full flex-col overflow-hidden rounded-3xl bg-cream text-left shadow-[0_18px_40px_-24px_rgba(34,21,16,0.45)] ring-1 ring-ink/5 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_30px_60px_-28px_rgba(218,33,40,0.45)]"
//     >
//       {/* Banner */}
//       <div className="relative h-44 overflow-hidden">
//         <div
//           className={`absolute inset-0 bg-gradient-to-br ${item.accent} transition-transform duration-500 group-hover:scale-105`}
//         />
//         {/* Decorative pattern */}
//         <div
//           className="absolute inset-0 opacity-25"
//           style={{
//             backgroundImage:
//               "radial-gradient(circle at 1px 1px, rgba(255,255,255,0.7) 1px, transparent 0)",
//             backgroundSize: "18px 18px",
//           }}
//         />
//         <div className="absolute -right-6 -top-6 h-28 w-28 rounded-full bg-cream/15 blur-xl" />
//         <div className="absolute -bottom-10 -left-6 h-32 w-32 rounded-full bg-ink/20 blur-2xl" />

//         {/* Index + icon */}
//         <div className="absolute left-4 top-4 flex items-center gap-2">
//           <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-cream/90 text-deeprose shadow-sm">
//             <Icon name={item.icon} className="h-5 w-5" />
//           </span>
//           {/* <span className="rounded-full bg-ink/25 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-cream backdrop-blur-sm">
//             {String(index + 1).padStart(2, "0")}
//           </span> */}
//         </div>

//         {/* Category tag */}
//         <span className="absolute right-4 top-4 rounded-full bg-cream/90 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-deeprose">
//           {item.category}
//         </span>

//         {/* Hover CTA */}
//         <div className="absolute bottom-3 right-4 flex translate-y-2 items-center gap-1.5 rounded-full bg-cream px-3 py-1.5 text-xs font-bold text-deeprose opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
//           Read & Download
//           <Icon name="arrow" className="h-3.5 w-3.5" />
//         </div>
//       </div>

//       {/* Body */}
//       <div className="flex flex-1 flex-col p-5">
//         <h3 className="font-display text-lg font-bold leading-snug text-ink transition-colors group-hover:text-brand">
//           {item.title}
//         </h3>
//         <p className="mt-1.5 text-sm leading-relaxed text-mute">
//           {item.subtitle}
//         </p>

//         <div className="mt-auto flex items-center justify-between pt-4">
//           <div className="flex items-center gap-1.5 text-xs font-medium text-mute">
//             <Icon name="calendar" className="h-3.5 w-3.5" />
//             {item.date}
//           </div>
//           <div className="flex items-center gap-1.5 text-xs font-semibold text-ink/60">
//             <Icon name="doc" className="h-3.5 w-3.5" />
//             {item.format} · {item.pages}p
//           </div>
//         </div>
//       </div>
//     </button>
//   );
// }







// // new new code 




// import Icon from "./Icon";

// /* A clickable banner card: image/gradient banner + title.
//    Clicking anywhere on the banner (or title) opens the detail view. */
// export default function BannerCard({ item, index, onOpen }) {
//   const hasImage = Boolean(item.img || item.image || item.thumbnail || item.banner);
//   const imgSrc = item.img || item.image || item.thumbnail || item.banner;
//   const accent = item.accent || "from-[#DA2128] to-[#8B0F1A]";

//   return (
//     <button
//       onClick={() => onOpen(item)}
//       className="group relative flex h-full flex-col overflow-hidden rounded-3xl bg-cream text-left shadow-[0_18px_40px_-24px_rgba(34,21,16,0.45)] ring-1 ring-ink/5 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_30px_60px_-28px_rgba(218,33,40,0.45)]"
//     >
//       {/* Banner */}
//       <div className="relative h-44 overflow-hidden">
//         {hasImage ? (
//           <>
//             <img
//               src={imgSrc}
//               alt={item.title || ""}
//               className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
//               onError={(e) => {
//                 e.currentTarget.style.display = "none";
//               }}
//             />
//             {/* dark scrim so the icon/category tag stay readable over any photo */}
//             <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-ink/10 to-transparent" />
//           </>
//         ) : (
//           <>
//             <div
//               className={`absolute inset-0 bg-gradient-to-br ${accent} transition-transform duration-500 group-hover:scale-105`}
//             />
//             {/* Decorative pattern */}
//             <div
//               className="absolute inset-0 opacity-25"
//               style={{
//                 backgroundImage:
//                   "radial-gradient(circle at 1px 1px, rgba(255,255,255,0.7) 1px, transparent 0)",
//                 backgroundSize: "18px 18px",
//               }}
//             />
//             <div className="absolute -right-6 -top-6 h-28 w-28 rounded-full bg-cream/15 blur-xl" />
//             <div className="absolute -bottom-10 -left-6 h-32 w-32 rounded-full bg-ink/20 blur-2xl" />
//           </>
//         )}

//         {/* Index + icon */}
//         <div className="absolute left-4 top-4 flex items-center gap-2">
//           <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-cream/90 text-deeprose shadow-sm">
//             <Icon name={item.icon || "doc"} className="h-5 w-5" />
//           </span>
//         </div>

//         {/* Category tag */}
//         {item.category && (
//           <span className="absolute right-4 top-4 rounded-full bg-cream/90 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-deeprose">
//             {item.category}
//           </span>
//         )}

//         {/* Hover CTA */}
//         <div className="absolute bottom-3 right-4 flex translate-y-2 items-center gap-1.5 rounded-full bg-cream px-3 py-1.5 text-xs font-bold text-deeprose opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
//           Read & Download
//           <Icon name="arrow" className="h-3.5 w-3.5" />
//         </div>
//       </div>

//       {/* Body */}
//       <div className="flex flex-1 flex-col p-5">
//         <h3 className="font-display text-lg font-bold leading-snug text-ink transition-colors group-hover:text-brand">
//           {item.title}
//         </h3>
//         {item.subtitle && (
//           <p className="mt-1.5 text-sm leading-relaxed text-mute">
//             {item.subtitle}
//           </p>
//         )}

//         <div className="mt-auto flex items-center justify-between pt-4">
//           <div className="flex items-center gap-1.5 text-xs font-medium text-mute">
//             <Icon name="calendar" className="h-3.5 w-3.5" />
//             {item.date}
//           </div>
//           {(item.format || item.pages) && (
//             <div className="flex items-center gap-1.5 text-xs font-semibold text-ink/60">
//               <Icon name="doc" className="h-3.5 w-3.5" />
//               {item.format}
//               {item.format && item.pages ? " · " : ""}
//               {item.pages ? `${item.pages}p` : ""}
//             </div>
//           )}
//         </div>
//       </div>
//     </button>
//   );
// }




// new new code 



import Icon from "./Icon";

/* Category → accent gradient + button color mapping
   (matches the look used in KnowledgeCenter's ReportCard / NewsletterCard) */
const ACCENTS = {
  Reports: {
    gradient: "linear-gradient(135deg, rgb(98,94,94) 0%, rgb(96,96,96) 50%, rgb(152,146,146) 100%)",
    button: "#F59C00",
    buttonShadow: "rgba(247,148,29,0.25)",
    label: "⬇ Download PDF",
  },
  Voice: {
    gradient: "linear-gradient(135deg, rgb(98,94,94) 0%, rgb(96,96,96) 50%, rgb(152,146,146) 100%)",
    button: "#8B0F1A",
    buttonShadow: "rgba(139,15,26,0.25)",
    label: "Read Full Issue →",
  },
  Bulletins: {
    gradient: "linear-gradient(135deg, rgb(98,94,94) 0%, rgb(96,96,96) 50%, rgb(152,146,146) 100%)",
    button: "#DA2128",
    buttonShadow: "rgba(218,33,40,0.25)",
    label: "View Bulletin →",
  },
  default: {
    gradient: "linear-gradient(135deg, rgb(98,94,94) 0%, rgb(96,96,96) 50%, rgb(152,146,146) 100%)",
    button: "#f7941d",
    buttonShadow: "rgba(247,148,29,0.25)",
    label: "View →",
  },
};

/* Same card design as KnowledgeCenter's ReportCard / NewsletterCard:
   scalloped gradient banner strip + floating image + title + date + CTA.
   Works for Reports / Voice / Bulletins — pass section.short as `variant`
   ("Reports" | "Voice" | "Bulletins") to switch accent colors + CTA label. */
export default function BannerCard({ item, index, onOpen, variant = "default" }) {
  const accent = ACCENTS[variant] || ACCENTS.default;

  const imgSrc = item.img || item.image || item.thumbnail || item.banner;
  const dateOrIssue = item.date || item.issue || "";

  return (
    <div
      className="card-hover"
      style={{
        background: "#FFFFFF",
        borderRadius: 24,
        overflow: "hidden",
        position: "relative",
        border: "1px solid #ececec",
        boxShadow: "0 10px 25px rgba(0,0,0,0.06)",
        transition: "0.35s ease",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Scalloped gradient banner strip */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: 90,
          background: accent.gradient,
          clipPath: "polygon(0 0, 100% 0, 100% 72%, 85% 100%, 60% 80%, 35% 100%, 0 72%)",
          zIndex: 0,
        }}
      />

      {/* Decorative translucent circle */}
      <div
        style={{
          position: "absolute",
          top: 18,
          right: 18,
          width: 48,
          height: 48,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.15)",
          backdropFilter: "blur(6px)",
          zIndex: 1,
        }}
      />

      {/* Category tag (top-left, optional) */}
      {/* {item.category && (
        <span
          style={{
            position: "absolute",
            top: 18,
            left: 20,
            zIndex: 2,
            background: "rgba(255,255,255,0.9)",
            color: accent.button,
            fontSize: 10,
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: "0.06em",
            padding: "4px 10px",
            borderRadius: 100,
          }}
        >
          {item.category}
        </span>
      )} */}

      {/* Floating image */}
      <button
        onClick={() => onOpen?.(item)}
        style={{
          position: "relative",
          padding: "26px 20px 0",
          zIndex: 2,
          border: "none",
          background: "transparent",
          cursor: "pointer",
          textAlign: "left",
          width: "100%",
        }}
      >
        <div
          style={{
            borderRadius: 18,
            overflow: "hidden",
            boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
          }}
        >
          <img
            src={imgSrc}
            alt=""
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
            style={{
              width: "100%",
              height: 360,
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>
      </button>

      {/* Body */}
      <div
        style={{
          padding: "18px 20px 22px",
          position: "relative",
          zIndex: 2,
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          onClick={() => onOpen?.(item)}
          style={{
            fontSize: 15,
            fontWeight: 700,
            color: "#222",
            lineHeight: 1.4,
            marginBottom: 8,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            cursor: "pointer",
          }}
        >
          {item.title}
        </div>

        <div style={{ fontSize: 12, color: "#888", marginBottom: 18 }}>
          {dateOrIssue}
        </div>

        {item.link ? (
          <a
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white transition-colors duration-300 hover:text-white"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              border: `2px solid ${accent.button}`,
              padding: "11px 18px",
              borderRadius: 100,
              fontSize: 12,
              fontWeight: 700,
              cursor: "pointer",
              transition: "0.3s",
              boxShadow: `0 6px 14px ${accent.buttonShadow}`,
              marginTop: "auto",
              textDecoration: "none",
              width: "fit-content",
              color: accent.button,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = accent.button;
              e.currentTarget.style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "#fff";
              e.currentTarget.style.color = accent.button;
            }}
          >
            {accent.label}
          </a>
        ) : (
          <button
            onClick={() => onOpen?.(item)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              border: `2px solid ${accent.button}`,
              padding: "11px 18px",
              borderRadius: 100,
              fontSize: 12,
              fontWeight: 700,
              cursor: "pointer",
              transition: "0.3s",
              boxShadow: `0 6px 14px ${accent.buttonShadow}`,
              marginTop: "auto",
              background: "#fff",
              color: accent.button,
            }}
          >
            {accent.label}
          </button>
        )}
      </div>
    </div>
  );
}